import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation,useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";


const MasterLayout = ({ children }) => {

  const imagePath1 = `https://aiwealth.blueastercapital.com/corporate/onboarding/assets/images/aiwealthlogo.png`
  const imagePath2 = `https://aiwealth.blueastercapital.com/corporate/onboarding/assets/images/aiwealthlogo.png`;
  const imagePath3 = `https://aiwealth.blueastercapital.com/corporate/onboarding/assets/images/aiwealthlogo.png`;


  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isActive, setActive] = useState(false);
  const [name, setName] = useState('');

  // const handleLogout = () => {
  //   sessionStorage.removeItem("authToken");
  //   toast.success("Logged out successfully!");
  //   navigate("/");

  // };
  const BaseUrl = process.env.REACT_APP_API;

  const handleLogout = async () => {
    try {
      const jwtToken = sessionStorage.getItem("authToken");

      await axios.post(
        `${BaseUrl}/logout`,
        {}, 
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("indDisclaimerAccepted");
      navigate("/login");
      toast.success("Logout Successful!");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");
      setActive(clickedDropdown.classList.contains("open"));
      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; 
        }
      });
     
   

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };
  

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (!token) {
      navigate("/");
    } 
  }, []);

    const validateToken = async (token) => {
      try {

        const baseUrl = process.env.REACT_APP_API;
    
        if (!baseUrl) {
          throw new Error("Base API URL is not defined in the environment file!");
        }
    
        const apiUrl = `${baseUrl}/validate-token`;
    
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });
    
        if (!response.ok) {
          throw new Error("Token validation request failed!");
        }
    
        const data = await response.json();
    
        if (data.valid) {
         
        } else {
          throw new Error(data.message || "Token validation failed.");
        }
      } catch (error) {
        console.error("Token validation failed:", error.message);
      }
    }

    const decodeToken = (token) => {
      try {
        const decoded = jwtDecode(token);
        return decoded.name || null;
      } catch (error) {
        console.error("Invalid token:", error);
        return null;
      }
    };
    
      useEffect(() => {
           const token = sessionStorage.getItem("authToken");
           const name = decodeToken(token);
           setName(name);
        if (token) {
          validateToken(token); 
        } else {
          navigate("/"); 
        }
      }, []);

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src={imagePath1}
              alt='site logo'
              className='light-logo'
            />
            <img
              src={imagePath2}
              alt='site logo'
              className='dark-logo'
            />
            <img
              src={imagePath3}
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='solar:home-smile-angle-outline'
                  className='menu-icon'
                />
                <span>Dashboard</span>
              </Link>
               
                
            </li> 
            <ul className='sidebar-submenu' hidden={isActive}>
                    <li>
                      <NavLink
                        to='/dashboard'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                        Portfolio
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/news&updates'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                        News and Updates
                      </NavLink>
                    </li>
                <li>
                  <NavLink
                    to='/media-articles'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Media Articles
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to='/ai-bot'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    AI Bot
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink
                    to='/crypto-signals'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Crypto Signals
                  </NavLink>
                </li> */}
                </ul> 

            <li className='sidebar-menu-group-titles'>Onboarding</li>
         
            <li>
              <NavLink
                to='/company-info'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='mdi:account' className='menu-icon' />
                <span>Company Info</span>
                
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/shareholders'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='mdi-account-multiple' className='menu-icon' />
                <span>Shareholders</span>
                
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/bank-documents'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='bi:bank' className='menu-icon' />
                <span>Bank Account</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/documents'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:documents-outline' className='menu-icon' />
                <span>Documents</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
               
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                <ThemeToggleButton />
            
                <div className='dropdown'>
                 <button
                  className='d-flex justify-content-center align-items-center rounded-circle bg-primary text-white'
                  type='button'
                  data-bs-toggle='dropdown'
                  style={{ width: '40px', height: '40px', border: 'none' }}
                >
                  <div className='fw-bold fs-5'>
                    {name ? name.charAt(0).toUpperCase() : ''}
                  </div>
                </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {name}
                        </h6>
                        
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/dashboard'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/change-password'
                        >
                          <Icon
                            icon='icon-park-outline:help'
                            className='icon text-xl'
                          />
                         Change Password
                        </Link>
                      </li>
                      <li>
                      <Link
                        className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                        to='/'
                        onClick={handleLogout}
                      >
                        <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                      </Link>
                    </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2025 AI Wealth Capital all rights reserved.</p>
            </div>
            {/* <div className='col-auto'>
              <p className='mb-0'>
              Crafted with   <span className='text-primary-600'>Blue aster</span>
              </p>
            </div> */}
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;

// import React, { useEffect, useState } from "react";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
// import ThemeToggleButton from "../helper/ThemeToggleButton";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// const MasterLayout = ({ children }) => {
//   const imagePath1 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR.png`;
//   const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR_Reverse.png`;
//   const imagePath3 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR.svg`;
//   const imagePath4 = `${process.env.PUBLIC_URL}/assets/images/user.png`;

//   const [sidebarActive, setSidebarActive] = useState(false);
//   const [mobileMenu, setMobileMenu] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const BaseUrl = process.env.REACT_APP_API;
//   const [isActive, setActive] = useState(false);

//   const handleLogout = async () => {
//     try {
//       const jwtToken = sessionStorage.getItem("authToken");

//       await axios.post(
//         `${BaseUrl}/logout`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         }
//       );
//       sessionStorage.removeItem("authToken");
//       sessionStorage.removeItem("indDisclaimerAccepted");
//       navigate("/login");
//       toast.success("Logout Successful!");
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   const validateToken = async (token) => {
//     try {
//       const apiUrl = `${BaseUrl}/validate-token`;

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ token }),
//       });

//       if (!response.ok) {
//         throw new Error("Token validation request failed!");
//       }

//       const data = await response.json();

//       if (!data.valid) {
//         throw new Error(data.message || "Token validation failed.");
//       }
//     } catch (error) {
//       console.error("Token validation failed:", error.message);
//       navigate("/login");
//     }
//   };

//   useEffect(() => {
//     const token = sessionStorage.getItem("authToken");
//     if (!token) {
//       navigate("/login");
//     } else {
//       validateToken(token);
//     }
//   }, [navigate]);

//   useEffect(() => {
//     const handleDropdownClick = (event) => {
//       event.preventDefault();
//       const clickedLink = event.currentTarget;
//       const clickedDropdown = clickedLink.closest(".dropdown");
  
//       if (!clickedDropdown) return;
  
//       const isActive = clickedDropdown.classList.contains("open");
//       setActive(clickedDropdown.classList.contains("open"));
  
//       // Close all dropdowns, but preserve the state if clicking on a submenu link
//       if (!clickedLink.closest(".sidebar-submenu")) {
//         const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
//         allDropdowns.forEach((dropdown) => {
//           dropdown.classList.remove("open");
//           const submenu = dropdown.querySelector(".sidebar-submenu");
//           if (submenu) {
//             submenu.style.maxHeight = "0px";
//           }
//         });
//       }
  
//       // Toggle the clicked dropdown
//       if (!isActive) {
//         clickedDropdown.classList.add("open");
//         const submenu = clickedDropdown.querySelector(".sidebar-submenu");
//         if (submenu) {
//           submenu.style.maxHeight = `${submenu.scrollHeight}px`;
//         }
//       }
//     };
  
//     const dropdownTriggers = document.querySelectorAll(
//       ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
//     );
  
//     dropdownTriggers.forEach((trigger) => {
//       trigger.addEventListener("click", handleDropdownClick);
//     });
  
//     const openActiveDropdown = () => {
//       const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
//       allDropdowns.forEach((dropdown) => {
//         const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
//         submenuLinks.forEach((link) => {
//           if (
//             link.getAttribute("href") === location.pathname ||
//             link.getAttribute("to") === location.pathname
//           ) {
//             dropdown.classList.add("open");
//             const submenu = dropdown.querySelector(".sidebar-submenu");
//             if (submenu) {
//               submenu.style.maxHeight = `${submenu.scrollHeight}px`;
//             }
//           }
//         });
//       });
//     };
  
//     openActiveDropdown();
  
//     // Cleanup event listeners on unmount
//     return () => {
//       dropdownTriggers.forEach((trigger) => {
//         trigger.removeEventListener("click", handleDropdownClick);
//       });
//     };
//   }, [location.pathname]);
  
//   const sidebarControl = () => {
//     setSidebarActive(!sidebarActive);
//   };

//   const mobileMenuControl = () => {
//     setMobileMenu(!mobileMenu);
//   };


//   return (
//     <section className={mobileMenu ? "overlay active" : "overlay"}>
//       <aside className={sidebarActive || mobileMenu ? "sidebar active" : "sidebar"}>
//         <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
//           <Icon icon="radix-icons:cross-2" />
//         </button>
//         <div>
//           <Link to="/" className="sidebar-logo">
//             <img src={imagePath1} alt="site logo" className="light-logo" />
//             <img src={imagePath2} alt="site logo" className="dark-logo" />
//             <img src={imagePath3} alt="site logo" className="logo-icon" />
//           </Link>
//         </div>
//         <div className="sidebar-menu-area">
//           <ul className="sidebar-menu" id="sidebar-menu">
//             <li className="dropdown">
//               <Link to="#">
//                 <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
//                 <span>Dashboard</span>
//               </Link>
             
//             </li>
//             <li>

//             <ul className="sidebar-submenu" hidden = {isActive}>
//                 <li>
//                   <NavLink to="/dashboard" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                     <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
//                     Portfolio
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink to="/news&updates" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                     <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
//                     News and Updates
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink to="/media-articles" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                     <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
//                     Media Articles
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink to="/ai-bot" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                     <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
//                     AI Bot
//                   </NavLink>
//                 </li>
//               </ul>
//             </li>

//             <li className="sidebar-menu-group-titlesddfsf">Onboarding</li>
//             <li>
//               <NavLink to="/basic-info" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                 <Icon icon="mdi:account" className="menu-icon" />
//                 <span>Basic Info</span>
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to="/bank-documents" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                 <Icon icon="bi:bank" className="menu-icon" />
//                 <span>Bank Account</span>
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to="/documents" className={(navData) => (navData.isActive ? "active-page" : "")}>
//                 <Icon icon="solar:documents-outline" className="menu-icon" />
//                 <span>Documents</span>
//               </NavLink>
//             </li>
//           </ul>
//         </div>
//       </aside>

//       <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
//         <div className="navbar-header">
//           <div className="row align-items-center justify-content-between">
//             <div className="col-auto">
//               <div className="d-flex flex-wrap align-items-center gap-4">
//                 <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
//                   {sidebarActive ? (
//                     <Icon icon="iconoir:arrow-right" className="icon text-2xl non-active" />
//                   ) : (
//                     <Icon icon="heroicons:bars-3-solid" className="icon text-2xl non-active" />
//                   )}
//                 </button>
//                 <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
//                   <Icon icon="heroicons:bars-3-solid" className="icon" />
//                 </button>
//               </div>
//             </div>
//             <div className="col-auto">
//               <div className="d-flex flex-wrap align-items-center gap-3">
//                 <ThemeToggleButton />
//                 <div className="dropdown">
//                   <button className="d-flex justify-content-center align-items-center rounded-circle" type="button" data-bs-toggle="dropdown">
//                     <img src={imagePath4} alt="user" className="avatar" />
//                   </button>
//                   <ul className="dropdown-menu dropdown-menu-end">
//                     <li>
//                       <button onClick={handleLogout} className="dropdown-item" type="button">
//                         Logout
//                       </button>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="content-area">{children}</div>
//       </main>
//     </section>

//   );
// };

// export default MasterLayout;
